(
    function (skyward, $, undefined)
    {
        skyward.tilebrowse = skyward.tilebrowse || {};

        var init = function (selector)
        {
            $(selector + " .tileRedirectButton").each(function ()
            {
                var tile = $(this);
                var tileData = tile.data();
                if ($.isEmptyObject(tileData))
                {
                    return;
                }

                skyward.tilebrowse.setupClickEvent(tile);

                var tileMarkPresentButton = tile.parent().find(".dailyAttendanceTileFooter .dailyAttendanceMarkPresentButton");
                var courseGrouping = $('#TeacherAccessGrouping').val();

                if (tileMarkPresentButton.length)
                {
                    var markAllPresentEnabled = false;

                    if ($('#ConfirmPerfectAttendance').length)
                    {
                        markAllPresentEnabled = $('#ConfirmPerfectAttendance').val().toLowerCase() === "true";
                    }

                    var markStudentsPresentAjax = function ()
                    {
                        var footerContainer = tileMarkPresentButton.parent();

                        tileMarkPresentButton.addClass("processing");
                        var processingColor = "#B0B0B0";

                        var buttonText = tileMarkPresentButton.find(".anchorText");
                        buttonText.text("Taking Attendance...");
                        buttonText.css("color", processingColor);

                        var buttonSvg = tileMarkPresentButton.find(".svg");
                        buttonSvg.css("fill", processingColor);

                        $.when(skyward.window.loadContent(footerContainer.attr('id'), 'Attendance', 'DailyAttendance', 'MarkStudentsPresent', tileData.defaultrowkey, { CourseGrouping: courseGrouping })).done(function ()
                        {
                            tileMarkPresentButton.remove();
                            var newButton = footerContainer.find('.dailyAttendanceTakenButton');
                            if (newButton.length)
                            {
                                newButton.one("click", function (event)
                                {
                                    skyward.browse.primaryButtonClick(tileData.browseid, tileData.tilenumber, tileData.target, tileData.module, tileData.object, tileData.screen, tileData.defaultrowkey, null, tileData.postdata, event, false);
                                });
                            }
                        }).fail(function (xhr, textStatus, error)
                        {
                            var options = { id: "options" };
                            var closeButton = { id: "closeButton", text: "Close", click: function () { dialog.close(); }, icon: "Close" };
                            var dialog = skyward.modalLayer.showDialog('Error', error, [closeButton], options);
                        });
                    };

                    var markPresentButtonFunction = function ()
                    {
                        if (markAllPresentEnabled)
                        {
                            $.ajax({
                                url: skyward.global.virtualDir + 'Attendance/DailyAttendance/GetNumberOfOfficeAbsences/' + tileData.defaultrowkey,
                                method: 'POST',
                                data: { CourseGrouping: courseGrouping },
                                success: function (data)
                                {
                                    if (data.isPerfectAttendance)
                                    {
                                        var saveButton =
                                        {
                                            id: "confirmPerfectAttendance",
                                            text: "Yes, Confirm",
                                            click: function ()
                                            {
                                                markStudentsPresentAjax();
                                                dialog.close();
                                            },
                                            icon: "Check"
                                        };
                                        var cancelButton =
                                        {
                                            id: "cancelPerfectAttendance",
                                            text: "No, Cancel",
                                            click: function ()
                                            {
                                                tileMarkPresentButton.one("click", markPresentButtonFunction);
                                                dialog.close();
                                            },
                                            icon: "Cancel"
                                        };
                                        var options =
                                        {
                                            id: "confirmPerfectAttendancePopup",
                                            width: 550,
                                            closeOnClick: false,
                                            closeOnEscape: false,
                                        };
                                        var dialog = skyward.modalLayer.showDialog("Confirm Perfect Attendance", "Are you sure you want to confirm Perfect Attendance?", [saveButton, cancelButton], options);
                                    }
                                    else
                                    {
                                        markStudentsPresentAjax();
                                    }
                                }
                            });
                        }
                        else
                        {
                            markStudentsPresentAjax();
                        }
                     };

                    tileMarkPresentButton.one("click", markPresentButtonFunction);
                }
            });
        };
        skyward.tilebrowse.setupClickEvent = function (tile)
        {
            var tileButtonData = tile.data();
            tile.one("click", function (event)
            {
                if (event.target && $(event.target).hasClass("tileBrowseIgnoreTileClick"))
                {
                    skyward.tilebrowse.setupClickEvent(tile);
                    return;
                }
                skyward.browse.primaryButtonClick(tileButtonData.browseid, tileButtonData.tilenumber, tileButtonData.target, tileButtonData.module, tileButtonData.object, tileButtonData.screen, tileButtonData.defaultrowkey, null, tileButtonData.postdata, event, false);
            });
        };
        //Bootstrap
        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);
